import { render } from "./GlobalFilters.vue?vue&type=template&id=10a80917&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./GlobalFilters.vue?vue&type=script&lang=js"
export * from "./GlobalFilters.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__